<!--
 * @Description: 成本列支
 * @Date: 2026-04-08 13:59:15
-->

<template>
  <BaseDialog
    width="960px"
    title="成本列支明细"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
  >
    <BaseTextContent>
      <XrkTable
        ref="xrkTableRef"
        :getListAjax="getListAjax"
        :searchConfig="searchConfig"
        :tableConfig="tableConfig"
      />
    </BaseTextContent>
    <template #footer>
      <BaseButton @click="remove" type="default">关闭</BaseButton>
    </template>
  </BaseDialog>
</template>
<script lang="tsx" setup>
import { ref } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useDatePickerColumn,
  useCreateModal,
  BaseButtonMore,
  BaseButton,
  XrkMessage,
  BaseDialog,
  BaseTextContent
} from 'xrk-components';
import { formatter } from '@/utils';
import {
  costItemList,
  costItemDownload,
  costItemExport
} from '../../data-source/apis';
import CostDetailDialog from './cost-detail-dialog.vue';

const props = defineProps<{
  remove?: () => void;
  individualId: number;
}>();

const xrkTableRef = ref();

const getListAjax = params => {
  const { incomeMonth, ...args } = params;
  return costItemList({ individualId: props.individualId, ...args });
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [
    useDatePickerColumn({
      prop: 'incomeMonth',
      label: '所属月份',
      config: {
        type: 'monthrange',
        valueFormat: 'YYYY-MM',
        startPlaceholder: '开始月份',
        endPlaceholder: '结束月份',
        clearable: true
      },
      listener: {
        onChange: (value, searchObj) => {
          if (!value) {
            searchObj.startAt = '';
            searchObj.endAt = '';
          } else {
            searchObj.startAt = value[0];
            searchObj.endAt = value[1];
          }
        }
      }
    })
  ],
  searchBtn: { show: true, text: '搜索' },
  resetBtn: { show: true, text: '重置' },
  otherComponents: [
    {
      render() {
        return (
          <>
            <BaseButton
              type="primary2"
              click={async () => {
                const selectionRows =
                  xrkTableRef.value.getSelectionRows() || [];
                if (!selectionRows?.length) {
                  XrkMessage.warning('请选择需要导出的数据');
                  return;
                }
                await costItemExport({
                  individualId: props.individualId,
                  ids: selectionRows.map(item => item.id).join(',')
                });
                XrkMessage.success('操作成功，请前往下载中心进行下载查看');
              }}
            >
              导出附件
            </BaseButton>
          </>
        );
      }
    }
  ]
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  baseConfig: { rowKey: 'id' },
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: 'id',
      align: 'center',
      fixed: 'left',
      width: 120
    }),
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px',
      fixed: 'left'
    }),
    useTableColumn({
      label: '所属月份',
      prop: 'incomeMonth'
    }),
    useTableColumn({
      label: '提交时间',
      prop: 'submitAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),

    useTableColumn({
      label: '操作',
      prop: 'handlerCol',
      fixed: 'right',
      width: '140px',
      render: ({ row }) => {
        const btns = [
          {
            content: '查看',
            click: () => {
              useCreateModal(CostDetailDialog, {
                id: row.id
              });
            }
          },
          {
            content: '下载',
            click: async () => {
              await costItemDownload({
                id: row.id,
                individualId: props.individualId
              });
            }
          }
        ].filter(Boolean);
        return (
          <BaseButtonMore
            key={Date.now()}
            maxCount={2}
            style={{ 'justify-content': 'right' }}
            btns={btns}
          ></BaseButtonMore>
        );
      }
    })
  ].filter(item => item)
});
</script>
